import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class PrintagentService {
  private apiSpringUrl = '/spring/printagent';

  constructor(
    private http: HttpService) { }

  get(): Promise<any> {
    // tslint:disable-next-line:max-line-length
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl + '/getlist';
    return this.http.get(url);
  }

  update(json?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl + '/update';
    return this.http.put(url, json);
  }
}


// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/printagent/printagent.service.ts